import React from 'react';
import { Typography } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { useUtexBalance } from '../Content/useUtexBalance';
import { MoneyView } from '../../../components/MoneyView';

export const UtexBalance: React.FC = () => {
  const { t } = useTranslation('byUtex');
  const { balance } = useUtexBalance();
  if (!balance) {
    return null;
  }
  return (
    <>
      <Typography.Text view="hint">{t('Available')}</Typography.Text>
      <Typography.Text view="normal">
        <MoneyView>{balance}</MoneyView>
      </Typography.Text>
    </>
  );
};
